import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, { FormBody, FormActions, TextInput, SelectInput } from '../../Form';
import moment from 'moment-timezone';
import { timezones } from '../../../libs/date';

@inject('stationStore', 'dataOriginStore')
@observer
class StationDataOriginEdit extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug = '/data-origin';
  title = 'Edit Station Data Origin';
  @observable item = {
    data_origin_id: '',
    timezone: '',
  };
  dispose;

  constructor(props) {
    super(props);

    const {
      params: { id, dataOriginId },
      stationStore,
      dataOriginStore,
    } = props;

    dataOriginStore.fetchItems();

    stationStore
      .fetchDataOrigin(id, dataOriginId)
      .then(action(json => {
        this.item = {
          data_origin_id: json.id,
          timezone: json.timezone,
          installed: json.installed,
        };
      }));
    ;
  }

  @action onChangeDataOrigin = (event) => {
    this.item.data_origin_id = +event.target.value;
  }
  @action onChangeTimezone = (event) => {
    this.item.timezone = event.target.value;
  }

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { params: { id, dataOriginId }, stationStore } = this.props;
    const slug = `/station/${id}/data-origin`;

    stationStore
      .updateDataOrigin(id, dataOriginId, this.item)
      .then(() => {
        this.context.router.push(slug);
        notify.success({ message: 'Updated Data Origin' });
      })
      .catch(action((err) => { notify.error(err); }));
  }

  render() {
    const { params: { id }, dataOriginStore } = this.props;
    const slug = `/station/${id}/data-origin`;

   const dataOrigins = dataOriginStore.items.toJS() || [];

    if (dataOriginStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={slug}>
        <Form>
          <FormBody>
            <SelectInput
              label={'Data Origin'}
              fields={{ label: 'code', value: 'id' }}
              options={dataOrigins}
              value={this.item.data_origin_id}
              onChange={this.onChangeDataOrigin}
            />
            <SelectInput
              label={'Timezone'}
              fields={{ label: 'offset', value: 'offset' }}
              options={timezones}
              value={this.item.timezone}
              onChange={this.onChangeTimezone}
            />
            <TextInput label={'Installed'} value={this.item.installed} readOnly />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default StationDataOriginEdit;



// WEBPACK FOOTER //
// ./src/components/Station/DataOrigin/StationDataOriginEdit.js